import _ from "lodash";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../utils";
import axios from "axios";

const initialState = {
  success: false,
  spec: {},
  loading: false,
  prevValue: null,
  oneMachineSetupOnly: false,
  machineSetupList: [],
  singleMachine: null,
};

export default function useGetSpec(selectOption) {
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  const [item, setItem] = useState(initialState);

  useEffect(() => {
    if (selectOption === null || selectOption === undefined) {
      return;
    } else {
      // eslint-disable-next-line no-unused-vars
      const { label, value } = selectOption;
      if (_.isEqual(value, item?.prevValue)) return;

      setItem({ ...initialState, prevValue: value, loading: true });
      async function callAPI() {
        async function innerFunction() {
          return await api
            .postS(
              `Quality/GetSpecificationByItemNumber`,
              { ItemNumber: value, IncludeMachineSetups: true },
              source.token
            )
            .then((r) => {
              if (r.data?.success) {
                const spec = r.data.item;
                let clone = _.cloneDeep(item);
                clone.spec = spec;
                clone.loading = false;
                clone.success = true;
                if (!_.isEmpty(spec.machineSetupList)) {
                  clone.machineSetupList = _.map(spec.machineSetupList, (x) => {
                    x.label = x.machineDescription;
                    x.value = x.machineType; // this should always have a value
                    return x;
                  });
                } else {
                  toast.error("there are no active machine setups for this item");
                  return;
                }
                if (
                  spec.machineSetupList &&
                  !_.isEmpty(spec.machineSetupList) &&
                  spec.machineSetupList.length === 1
                ) {
                  clone.oneMachineSetupOnly = true;
                  clone.singleMachine = clone.machineSetupList[0];
                }

                setItem(clone);
              } else {
                toast.error(`This Specification does not exist ${value}`);
              }
            })
            .catch(api.catchHandler);
        }

        await innerFunction();
      }
      callAPI();
    }

    return () => {
      source.cancel("axios request cancelled");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOption]);

  return item;
}
